import React from "react";
export default function TheHeritageOfHospitality() {
  return <section data-section-id="224790" id="halal-bold" className="relative bg-background text-foreground py-24 md:py-32 lg:py-40 overflow-hidden">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none opacity-[0.05] bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648254/img/punjabi_pattern_texture.png)] bg-center bg-no-repeat bg-contain" aria-hidden="true" />

      <div className="container relative z-10 mx-auto px-4">
        <div className="max-w-[800px] mx-auto text-center flex flex-col items-center">
          
          <h2 className="font-default text-4xl md:text-5xl lg:text-7xl text-primary mb-12 uppercase font-bold tracking-wider">
            Halal & Bold
          </h2>

          <div className="space-y-8 text-lg md:text-xl text-foreground/90 font-default leading-[1.8]">
            <p>
              At Sultani Grill & Burgers, our heritage is measured in the heat of the tandoor and the depth of our hand-ground spices. We bring the unapologetic flavors of Punjab to the heart of Irving, serving a fusion that honors tradition while breaking every rule of ordinary dining.
            </p>
            
            <div className="flex items-center justify-center gap-4 py-4">
              <div className="h-[1px] w-12 bg-primary" />
              <div className="w-3 h-3 rotate-45 bg-primary" />
              <div className="h-[1px] w-12 bg-primary" />
            </div>

            <p>
              Every cut of meat is 100% Zabiha Halal certified, ensuring that our commitment to quality is as absolute as our commitment to flavor. From our signature smash burgers to our slow-cooked karahis, we use only premium ingredients to craft a menu that is as bold as the city we call home.
            </p>
            <p>
              This isn't just a meal; it's a high-contrast culinary experience. We invite you to step into the dark, embrace the spice, and discover why Sultani is the new standard for Punjabi-American fusion.
            </p>
          </div>

          <div className="mt-16 md:mt-24 flex flex-col items-center">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648254/img/halal_seal_blaze_orange.png" alt="100% Halal Certified Seal" className="h-16 md:h-24 mb-6 object-contain" />
            <span className="text-xs md:text-sm tracking-[0.2em] uppercase text-primary font-default font-bold">
              Certified Zabiha Halal
            </span>
          </div>

        </div>
      </div>
    </section>;
}